// React
import { ReactElement } from 'react';
// Next
import { useTranslation } from 'next-i18next';
// Interfaces
import { DisplayListResultProps } from '@utmb/types/display-list-result';
// Design System
import { Font } from '@utmb/design-system/text/font';
// Styles
import styles from './display-list-result.module.scss';

export const DisplayListResult = (props: DisplayListResultProps): ReactElement => {
    const { label, hits } = props;

    const { t } = useTranslation();

    return (
        <>
            {label && (
                <Font.OxaniumBold className={styles.title} mobile="16" desktop="18" as="h2">
                    {label}
                </Font.OxaniumBold>
            )}
            <Font.OxaniumBold className={styles.hit_qty} mobile="16" desktop="18" as="h2">
                {!!hits ? `${hits} ${t(`common.result.${hits > 1 ? 'plural' : 'singular'}`)}` : t('common.noResult')}
            </Font.OxaniumBold>
        </>
    );
};
